<template>
  <div class="d-flex-column justify-start align-start gap-20">
    <div class="d-flex-column justify-start align-start gap-5">
      <h4 class="t-white font-family-1 title-h5 f-w-600">
        {{ $t("path_of_exile.gear_type") }}
      </h4>
    </div>

    <div class="gear_type_picker b-radius-12">
      <button
        v-for="option in gearTypes"
        class="role_picker d-flex-row height-max-content gap-5 medium-l font-family-2"
        :key="option.id"
        :class="[checkoutStore.getDetails?.gearId === option.id && 'selected']"
        @click.stop="setGearType(option)"
      >
        <p class="t-white medium-l font-family-2">
          {{ option.title }}
        </p>
      </button>
    </div>
  </div>
</template>

<script setup>
const { getGamePack } = useGameStore();
const checkoutStore = useCheckoutStore();
const gearTypes = computed(() => {
  return getGamePack?.prices || [];
});

const setGearType = (gear) => {
  checkoutStore.setDetails({
    gearTitle: gear.title,
    gearId: gear.id,
  });
};
</script>

<style lang="scss" scoped>
.gear_type_picker {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  padding: 12px;
  border: 1px solid var(--stroke-dark);

  @media screen and (max-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
